import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { isFedrampModerate } from '@atlaskit/atlassian-context';
import { fg } from '@atlaskit/platform-feature-flags';
import GlobalInteractionSessionTracking from './globalInteractionSessionTracking';
import SafeSessionStorage from './storage/SafeSessionStorage';
export var INTERACTION_SESSION_SOURCE_KEY = 'interactionSession.source';
export var INTERACTION_SESSION_BRIDGE_KEY = 'interactionSession.bridge';
/**
 * AnalyticsCrossProductInteractionClient is a wrapper for the InteractionSessionTracking class.
 * It is designed to be used internally within the Atlassian Analytics Pipeline as well as useCrossProductUrlWrapper hook.
 * It is not intended to be used directly by end-users.
 *
 * This will create an instance of the interaction session tracker on the window object, which can be shared across different parts of a document.
 * If the internal client already exists, it will use the existing instance. Creating the client in a singleton manner like this enables us
 * to debounce updates to Session Storage, which is important when a large number of links using our hook are rendered on a page.
 *
 * The other interaction session parameters are written directly to session storage as they are predominantly read-only,
 * with the only update being the initialisation of the client
 */
var AnalyticsCrossProductInteractionClient = /*#__PURE__*/_createClass(
// TODO: Make these fields non-nullable once feature flag removed

function AnalyticsCrossProductInteractionClient(interactionSessionOptions, bridge, interactionSource) {
  var _this = this;
  _classCallCheck(this, AnalyticsCrossProductInteractionClient);
  _defineProperty(this, "getCurrentInteractionSessionId", function () {
    return _this.isEnabled && _this.interactionSessionTracking ? _this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
  });
  _defineProperty(this, "getPreviousInteractionSessionId", function () {
    return _this.isEnabled && _this.interactionSessionTracking ? _this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
  });
  _defineProperty(this, "getBridge", function () {
    return _this.isEnabled && _this.safeSessionStorage ? _this.safeSessionStorage.getItem(INTERACTION_SESSION_BRIDGE_KEY) : null;
  });
  _defineProperty(this, "getInteractionSource", function () {
    return _this.isEnabled && _this.safeSessionStorage ? _this.safeSessionStorage.getItem(INTERACTION_SESSION_SOURCE_KEY) : null;
  });
  this.isEnabled = fg('analytics_cross_product_interaction_tracking') && !isFedrampModerate();
  if (this.isEnabled) {
    // Get singleton interaction session tracking instance
    this.interactionSessionTracking = GlobalInteractionSessionTracking.getInstance();
    var isValidPersistedId = false;
    if (this.interactionSessionTracking) {
      if (interactionSessionOptions) {
        this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
        isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
      }
    }
    this.safeSessionStorage = new SafeSessionStorage();

    // Store other interaction session parameters directly in session storage if ID has been validated
    if (isValidPersistedId) {
      bridge && this.safeSessionStorage.setItem(INTERACTION_SESSION_BRIDGE_KEY, bridge);
      interactionSource && this.safeSessionStorage.setItem(INTERACTION_SESSION_SOURCE_KEY, interactionSource);
    }
  }
});
export { AnalyticsCrossProductInteractionClient as default };